/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { CoolantLevelIcon } from '@commander-services/cmd-icon';
import { isOnlinePanelOpenAtom, IVehicleOnlinePanels, onlinePanelAtom } from '../OnlinePanelState';
import { ICustomWidgetProps } from './Widget';
import RemoveButton from './RemoveButton';

export default function CoolantLevelLowWidget(props: ICustomWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [widgetData, setWidgetData] = React.useState<boolean | null>(true);

  const vehicleId = useRecoilValue<number | false>(isOnlinePanelOpenAtom);
  const onlinePanelData = useRecoilValue<IVehicleOnlinePanels>(onlinePanelAtom);

  React.useMemo(() => {
    if (!props.isMockupMode) {
      const onlinePanel = onlinePanelData[Number(vehicleId)];

      if (
        onlinePanel &&
        typeof vehicleId === 'number' &&
        typeof onlinePanel.coolantLevelLow === 'boolean'
      ) {
        setWidgetData(onlinePanel.coolantLevelLow);
      } else {
        setWidgetData(null);
      }
    }
  }, [onlinePanelData, props.isMockupMode, vehicleId]);

  let widgetTooltip: string = '';

  if (widgetData === null) {
    widgetTooltip = f({ id: 'enum.onlineMap.widget.types.coolantLevelLow' });
  } else if (widgetData === false) {
    widgetTooltip = f({ id: 'widget.coolantLevelLow.tooltip.no' });
  } else if (widgetData === true) {
    widgetTooltip = f({ id: 'widget.coolantLevelLow.tooltip.yes' });
  }

  if (!props.isInGrid && props.isMockupMode) {
    widgetTooltip = f({ id: 'onlineTemplates.subPage.section.widgets.tooltip' });
  }

  const onDragStart = props.isInGrid ? undefined : props.onDragCallback;

  const renderWidget = () => {
    if (widgetData === true && !props.isMockupMode) {
      return (
        <CoolantLevelIcon
          className="e-widget-icon"
          data-cy="coolant-widget-active"
          color="#F5884E"
        />
      );
    }
    return <CoolantLevelIcon className="e-widget-icon" data-cy="coolant-widget-mode" />;
  };

  return (
    <div
      data-cy="coolant-widget"
      className={`b-widget b-widget--${props.data.rowSize}x${props.data.columnSize}
      widget-grid-name-${props.data.gridName} ${props.isInGrid ? '' : 'droppable-element'}`}
      draggable={!props.isInGrid}
      onDragStart={onDragStart}
      title={widgetTooltip}
      style={{ position: 'relative' }}
    >
      {props.isInGrid && (
        <RemoveButton
          dataCy="coolant-widget-in-grid"
          onRemoveCallback={props.onRemoveCallback}
          gridName={props.data.gridName}
        />
      )}
      {props.data.columnSize === 1 && props.data.rowSize === 1 && widgetData !== null ? (
        renderWidget()
      ) : (
        <CoolantLevelIcon className="e-widget-icon" color="#b7b7b7" />
      )}
    </div>
  );
}
